export enum NoOfSharesHistoryType {
  Initial = 'INITIAL',
  ShareSplit = 'SHARE_SPLIT',
  Exit = 'EXIT',
  Transfer = 'INVESTMENT_TRANSFER',
}
